import Button from './components/Button.esm.js';

const getOverrides = (theme) => ({
    MuiButton: Button(theme),
});

export { getOverrides as default };
